export default (clients = [], action) => {
    switch (action.type) {
        case 'FETCH_ALL':
            return action.payload;
        case 'CREATE':
            return [...clients, action.payload];
        case 'DELETE':
            return clients.filter((client) => client._id != action.payload);
        default:
            return clients;
    }
}